import { status } from 'skin/event/status';

const row = (obj, ms, story, data, d, action) => {
	const list = data.curData.values.table.tnk_state.list
	const idx = []
	list.forEach(el => {
		if (el.key === obj.key) {
			idx.push(obj.key)
			data.setCell("tnk_state", el.key, 0, "+");
		}
	})
	return status.ignore
};

export default row;
